import { ICreateInspecaoObraExecutadoPorUseCase } from "../../../presentation/useCases/create/create_inspecao_obra_executado_por_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * CreateInspecaoObraExecutadoPorUseCase
 */

export class CreateInspecaoObraExecutadoPorUseCase implements ICreateInspecaoObraExecutadoPorUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async createInspecaoObraExecutadoPor(
    idObra: number,
    idInspecaoObra: number,
    realizadoPor: number,
    idFornecedor: number | null,
    funcionarios: number[] | null,
  ): Promise<void> {
    await this.repository.createInspecaoObraExecutadoPor(
      idObra,
      idInspecaoObra,
      realizadoPor,
      idFornecedor,
      funcionarios,
    );
  }
}
